import { MenuIcon, MultiSelect, PriceBandIcon, RadioSelect, ViewIcon } from '@weareopenr/component-library';
import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';
import { IMenu } from 'src/types/menu.types';
import { ChannelFilter } from '../ChannelFilter';
import { PriceBandFilter } from '../PriceBandFilter';

export const ALL_PRODUCTS = 'all_products';
export const MISSING_DEFAULT_PRICE_ONLY = 'missing_default_price_only';
export const EXPAND_ALL = 'expand_all';
export const COLLAPSE_ALL = 'collapse_all';

const missingDefaultPriceOptions = [
  { id: ALL_PRODUCTS, label: 'All Products' },
  { id: MISSING_DEFAULT_PRICE_ONLY, label: 'Null Prices only' },
];

const dropdownViewOptions = [
  { id: EXPAND_ALL, label: 'Expand All' },
  { id: COLLAPSE_ALL, label: 'Collapse All' },
];

type PriceSchemeFiltersProps = {
  menus: IMenu[];
  searchMenus: string[];
  setSearchMenus: (menus: string[]) => void;
  hasPricingCategoryFilterFeature: boolean;
  searchPricingCategories?: string[];
  pricingCategoryOptions?: SelectedMultiOption[];
  setSearchPricingCategories?: (categories: string[]) => void;
  channelOptions?: SelectedMultiOption[];
  searchChannels?: string[];
  setSearchChannels?: (channels: string[]) => void;
  priceBandOptions?: SelectedMultiOption[];
  selectedPriceBands?: string[];
  setSelectedPriceBands?: (priceBands: string[]) => void;
  missingDefaultPriceFilter: string;
  setMissingDefaultPriceFilter: (id: string) => void;
  expandCollapseFilter: string;
  setExpandCollapseFilter: (id: string) => void;
};

export const PriceSchemeFilters = ({
  menus,
  searchMenus,
  setSearchMenus,
  hasPricingCategoryFilterFeature,
  pricingCategoryOptions = [],
  searchPricingCategories,
  setSearchPricingCategories,
  channelOptions = [],
  searchChannels = [],
  setSearchChannels,
  priceBandOptions = [],
  selectedPriceBands = [],
  setSelectedPriceBands,
  missingDefaultPriceFilter,
  setMissingDefaultPriceFilter,
  expandCollapseFilter,
  setExpandCollapseFilter,
}: PriceSchemeFiltersProps) => (
  <>
    <RadioSelect
      label="Table View"
      Icon={ViewIcon}
      options={[
        {
          heading: 'View Filters:',
          options: missingDefaultPriceOptions,
          selected: missingDefaultPriceFilter,
          onChange: setMissingDefaultPriceFilter,
        },
        {
          heading: 'Dropdown View:',
          options: dropdownViewOptions,
          selected: expandCollapseFilter,
          onChange: setExpandCollapseFilter,
        },
      ]}
    />
    {menus?.length > 0 && (
      <MultiSelect
        Icon={MenuIcon}
        label="Menus"
        options={menus?.map((menu, index) => ({ id: menu.menuId, label: menu.name, display_order: index })) || []}
        selected={searchMenus}
        onChange={setSearchMenus}
        disabled={menus?.length === 0}
      />
    )}
    {hasPricingCategoryFilterFeature && pricingCategoryOptions.length > 0 && (
      <MultiSelect
        Icon={PriceBandIcon}
        label="Pricing Categories"
        options={pricingCategoryOptions}
        selected={searchPricingCategories}
        onChange={setSearchPricingCategories}
      />
    )}
    <ChannelFilter options={channelOptions} selected={searchChannels} onChange={setSearchChannels} />
    <PriceBandFilter options={priceBandOptions} selected={selectedPriceBands} onChange={setSelectedPriceBands} />
  </>
);
